//
//

import { mapActions, mapGetters } from "vuex";
import { uid } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDataTable from "@/components/Generics/AQDataTable/AQDataTable.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import DataAuditModal from "./DataAuditModal.vue";
import CreateColumnModal from "./CreateColumnModal.vue";
import { DUMMY_TABLE_DATA, DUMMY_TABLE_COLUMNS } from "./consts";
import ExportEntityModal from "./ExportEntityModal.vue";
import ImportDataEntityModal from "./ImportDataEntityModal.vue";
import PermissionsModal from "./PermissionsModal.vue";
import ExportPanel from "./ExportPanel.vue";
import ExportAuditPanel from "./ExportAuditPanel.vue";

export default {
    name: "EntityTable",
    components: {
        AQButton,
        AQTooltip,
        AQMenu,
        AQDataTable,
        AQBadge,
        AQListBtn,
        AQInput,
        AQDropdown,
        AQDialog,
        CreateColumnModal,
        ExportEntityModal,
        ImportDataEntityModal,
        PermissionsModal,
        ExportPanel,
        ExportAuditPanel,
        DataAuditModal
    },
    props: {
        entity: {
            type: Object,
            default: () => ({ name: "", code: "" })
        },
        tablePagination: {
            type: Object,
            default: () => ({})
        },
        dataForTable: {
            type: Array,
            default: () => []
        },
        tableColumns: {
            type: Array,
            default: () => []
        },
        rowIdsSet: {
            type: Set,
            default: new Set()
        },
        headerOptions: {
            type: Array,
            default: () => []
        },
        attributesListToSend: {
            type: Array,
            default: () => []
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        isExternal: {
            type: Boolean,
            default: false
        },
        resetCurrentPage: {
            type: Boolean,
            default: false
        },
        loadingDummyColumns: {
            type: Boolean,
            default: false
        },
        errorRetrievingData: {
            type: Boolean,
            default: false
        },
        loadingData: {
            type: Boolean,
            default: true
        },
        isLegacy: {
            type: Boolean,
            default: false
        },
        iid: {
            type: Symbol,
            default: null
        },
        isAuditMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tableData: DUMMY_TABLE_DATA,
            columns: DUMMY_TABLE_COLUMNS,
            isAlert: false,
            showDialog: false,
            showDialogWarning: false,
            showBulkDialog: false,
            deleteAllDialog: false,
            bulkDeleteMode: false,
            openWarning: false,
            resetSelectedData: false,
            openColumnModal: false,
            openExportEntityModal: false,
            openImportDataEntityModal: false,
            openDataAudit: false,
            openImportDataModal: false,
            permissionsModal: false,
            saveDisabled: false,
            selectAllRows: false,
            inputValueChanged: false,
            focusedCell: null,
            dataForSaveRequest: {},
            invalidCellIds: {},
            propsSelection: {
                hideHeader: false,
                hideBottom: false,
                showTableTitle: false,
                mobileView: false,
                addExtraTopRow: false,
                addExtraBottomRow: false,
                showSettings: false,
                reorderColumns: false,
                noData: false,
                selection: "none",
                separator: "cell"
            },
            deleteColumn: {
                name: "deleteColumn",
                align: "center",
                label: "",
                field: "column0",
                visible: true,
                id: uid()
            },
            showMenu: [],
            selectedRowIds: [],
            hideList: ["edit", "more", "copy", "download"],
            deleteOptions: [
                {
                    value: "deleteAllData",
                    label: this.$t("globalDataModel.deleteAllData")
                }
            ],
            sourceOptions: [
                {
                    value: "aurachain",
                    label: ""
                }
            ],
            booleanOptions: [
                {
                    value: true,
                    label: this.$t("catalogs.true")
                },
                {
                    value: false,
                    label: this.$t("catalogs.false")
                }
            ],
            showExportMenu: false,
            showAuditExport: false

        };
    },
    computed: {
        ...mapGetters("dataStore", [
            "exportFinished",
            "getImportInProgress"
        ]),
        ...mapGetters("users", ["usersInfo"]),
        getTableProps() {
            const { rowsPerPage = 10, total = 0, page = 1 } = this.tablePagination || {};
            return {
                noDataDefaultTableHeight: "100%",
                atId: "entity-table",
                columns: this.columns,
                defaultColumns: this.columns,
                tableData: this.tableData,
                totalPages: Math.ceil(total / rowsPerPage),
                pagination: { page },
                selection: this.propsSelection.selection,
                hideBottom: this.propsSelection.hideBottom,
                hideHeader: this.propsSelection.hideHeader,
                selectTableRows: this.tableDefaultSelectionList,
                resetCurrentPage: this.resetCurrentPage,
                separator: this.propsSelection.separator,
                grid: this.propsSelection.mobileView,
                showSettings: this.propsSelection.showSettings,
                reorderColumns: this.propsSelection.reorderColumns,
                loading: this.loadingData
            };
        },
        nothingToSave() {
            return !this.inputValueChanged && !Object.keys(this.dataForSaveRequest).length;
        },
        createColumntModalProps() {
            return {
                addAttInEntity: this.addAttInEntity,
                isEdit: this.openAttEdit,
                attDataToEdit: this.attDataToEdit,
                entityData: this.entity,
                attIsPublished: true,
                atributesList: this.attributesListToSend
            };
        },
        getPublishedStatus() {
            return true;
        },
        headerMenu() {
            const [permissions, , exportData, importData, dataAudit, deleteData, deleteTable] = this.headerOptions;
            if (!this.$oneAtATime.state.$currentRoomEmpty) {
                return [
                    permissions,
                    { ...importData, itemDisabled: true },
                    dataAudit,
                    exportData,
                    { ...deleteData, itemDisabled: true },
                    { ...deleteTable, itemDisabled: true }
                ];
            }
            return [permissions, importData, dataAudit, exportData, { ...deleteData, itemDisabled: !this.tableData.length }, deleteTable];
        }
    },
    watch: {
        selectedRowIds: {
            handler(newVal) {
                this.selectedRowIdsHandler(newVal);
            },
            immediate: false
        },
        dataForTable: {
            handler(newVal) {
                this.tableData = newVal.map(row => ({ ...row }));
                this.dataForSaveRequest = {};
                this.invalidCellIds = {};
                this.saveDisabled = false;
                this.inputValueChanged = false;
                if (this.bulkDeleteMode) {
                    this.selectedRowIdsHandler(this.selectedRowIds);
                }
            },
            deep: true
        },
        nothingToSave: {
            handler(newVal) {
                this.$emit("nothingToSave", newVal);
                this.$store.commit("main/setInterfaceDirty", !newVal);
            }
        },
        saveDisabled: {
            handler(newVal) {
                this.$root.$emit("disableSaveButton", newVal);
            },
            immediate: true
        },
        tableColumns: {
            handler(newVal) {
                this.dataForSaveRequest = {};
                this.invalidCellIds = {};
                this.saveDisabled = false;
                this.inputValueChanged = false;
                this.exitBulkDeleteMode();
                this.columns = [...newVal];
            },
            deep: true
        }
    },
    created() {
        this.$root.$on("dataStoreSave", () => {
            this.$store.commit("main/setInterfaceDirty", false);
            this.saveData();
        });
        this.$root.$on("oneAtATime-dataStore", () => {
            this.$root.$emit("setReadonlyTag", !this.$oneAtATime.state.$currentRoomEmpty);
        });
    },
    methods: {
        ...mapActions("dataStore", [
            "getIntegrations",
            "getAttributes",
            "saveEntityData",
            "deleteAllData",
            "getEntityData",
            // "getExternalEntityData",
            "deleteRows"
            // "getExternalDescriptor"
        ]),
        getRowIid(row) {
            return row[this.iid];
        },
        setBadgeType(col) {
            let badge = "string";
            if (col.type) {
                badge = col.type;
            }
            return badge;
        },
        getIntegrationList(isCreate) {
            this.getIntegrations().then(integrations => {
                const integrationsList = integrations.data.dbConnections.map(item => ({
                    label: item.connectionName,
                    value: item.connectionCode,
                    dbType: item.dbType
                }));
                integrationsList.unshift(this.sourceOptions[0]);
                this.sourceOptions = [...integrationsList];
                if (isCreate) {
                    this.openCreateEntityModal = true;
                    this.openEditModal = false;
                } else {
                    this.openCreateEntityModal = true;
                    this.openEditModal = true;
                }
            });
        },
        setCellClass(idx, type, props) {
            const cellClass = [];
            if (idx === 0) {
                cellClass.push("delete-icon-border");
            } else if (type === "attachment") {
                if (props.rowIndex % 2 === 0) {
                    cellClass.push("attachment-bg-white");
                } else {
                    cellClass.push("attachment-bg-grey");
                }
                cellClass.push("attachment-border");
            }
            return cellClass;
        },
        isInput(type) {
            return type === "string" || type === "integer" || type === "decimal" || type === "serial";
        },
        isDropdown(type) {
            return type === "BOOLEAN";
        },
        isDatetime(type) {
            return type === "date" || type === "datetime" || type === "time";
        },
        dateTimeType(type) {
            return type ? type.toLowerCase() : type;
        },
        setDefaultValue(item) {
            return typeof item === "boolean" ? item : "";
        },
        dateModelMask(type) {
            const masks = {
                time: "HH:mm:ssZ",
                date: "YYYY-MM-DD",
                datetime: "YYYY-MM-DDTHH:mm:ssZ"
            };
            return masks[String(type).toLowerCase()];
        },
        dateMask(type) {
            const masks = {
                time: "HH:mm",
                date: "YYYY/MM/DD",
                datetime: "YYYY/MM/DD HH:mm"
            };
            return masks[String(type).toLowerCase()];
        },
        removerRowBorder(rowElement) {
            this.$refs[rowElement].$el.classList.remove("delete-row-hover");
        },
        setRowBorder(rowElement) {
            this.$refs[rowElement].$el.classList.add("delete-row-hover");
        },
        setInputCellClass(idx, code, { "#event": event, "#oldData": oldData = {} }) {
            const auditDefaultColumns = ["#processInstanceId",
                "#applicationId", "#modifiedVia", "#modifiedBy", "#modifiedByUserId", "#eventDate", "#event", "#id"];
            let cellClass = [];
            const even = idx % 2 === 0;

            if (code === "#id" && even) {
                cellClass.push("row-bg-lightGrey");
            } else if ((code === "#id" && !even)) {
                cellClass.push("row-bg-darkGrey");
            } else if (code !== "#id" && even) {
                cellClass.push("row-bg-white");
            } else {
                cellClass.push("row-bg-grey");
            }
            if (this.isAuditMode && !auditDefaultColumns.includes(code) && (event === "ADD" || event === "DELETE" || oldData[code] !== undefined)) {
                cellClass = [`audit-${event.toLowerCase()}`];
            }
            return cellClass;
        },
        setVal({ row, col, val, type, cellId }) {
            const canSave = type === "string" || type === "integer" || type === "decimal";
            let value = val === null ? "" : val;
            if (type === "BOOLEAN") {
                value = val && val.length ? val[0].value : "";
            } else if (type === "integer" || type === "decimal") {
                this.checkDataType({ val, type, cellId });
            } else if (type === "string") {
                this.cellValueChanged = true;
                this.inputValueChanged = true;
            }
            if (!canSave) {
                this.tableData[row][col] = value;
                this.setRowForSave(this.tableData[row][this.iid]);
            }
        },
        setFocusElement(element, type, iid, idx) {
            if (type === "integer" || type === "decimal") {
                [this.focusedCell] = this.$refs[iid + idx];
            }
        },
        checkDataType({ val, type, cellId }) {
            const isDecimal = /^[+-]?\d*\.?,?\d*$/;
            const isInteger = /^[+-]?\d*$/;
            const regex = type === "decimal" ? isDecimal : isInteger;
            if (regex.test(val) || !val) {
                if (this.invalidCellIds.hasOwnProperty(cellId.key) && this.invalidCellIds[cellId.key].includes(cellId.value)) {
                    const cellIdIdx = this.invalidCellIds[cellId.key].indexOf(cellId.value);
                    this.invalidCellIds[cellId.key].splice(cellIdIdx, 1);
                }
            } else if (this.invalidCellIds.hasOwnProperty(cellId.key)) {
                if (!this.invalidCellIds[cellId.key].includes(cellId.value)) {
                    this.invalidCellIds[cellId.key].push(cellId.value);
                }
            } else {
                this.invalidCellIds[cellId.key] = [cellId.value];
            }
            if (this.invalidCellIds[cellId.key] && !this.invalidCellIds[cellId.key].length) {
                delete this.invalidCellIds[cellId.key];
            }
            const isCellInvalid = this.invalidCellIds[cellId.key] && this.invalidCellIds[cellId.key].includes(cellId.value);
            if (this.focusedCell) {
                if (isCellInvalid) {
                    this.focusedCell.$el.firstChild.firstChild.firstChild.classList.add("invalid-cell-type-border-color");
                } else {
                    this.focusedCell.$el.firstChild.firstChild.firstChild.classList.remove("invalid-cell-type-border-color");
                }
            }
            this.inputValueChanged = true;
            this.cellValueChanged = true;
            this.saveDisabled = !!Object.keys(this.invalidCellIds).length;
        },
        showValidationNotication(type) {
            if (this.saveDisabled) {
                if (type === "integer") {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("globalDataModel.onlyInteger"),
                        timeout: 500
                    });
                } else if (type === "decimal") {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("globalDataModel.onlyDecimal"),
                        timeout: 500
                    });
                }
            }
        },
        changePagination(event) {
            if (this.nothingToSave) {
                this.$emit("changePagination", event);
            } else {
                this.openWarning = true;
                this.okActionEntity = () => {
                    this.$emit("changePagination", event);
                };
                this.cancelActionEntity = () => {
                    this.$emit("changePagination", "cancel");
                };
            }
        },
        confirmAction(row, index) {
            this.isAlert = true;
            this.showDialog = true;
            row.index = index;
            this.selectedRowForRemoval = row;
        },
        confirmBulkAction() {
            this.isAlert = true;
            this.showBulkDialog = true;
        },
        enterBulkDeleteMode() {
            if (this.nothingToSave) {
                this.bulkDeleteMode = true;
                this.selectedRowIds = [];
            } else {
                this.openWarning = true;
                this.okActionEntity = () => {
                    this.refreshData();
                    this.bulkDeleteMode = true;
                    this.selectedRowIds = [];
                };
            }
        },
        exitBulkDeleteMode() {
            this.bulkDeleteMode = false;
            this.selectedRowIds = [];
        },
        setRowForSave(rowId) {
            if (this.dataForSaveRequest[rowId] !== "add") {
                this.dataForSaveRequest = { ...this.dataForSaveRequest, [rowId]: "edit" };
            }
        },
        saveDataInTable({ type, row, col, value }) {
            if (this.cellValueChanged) {
                if (type === "integer" || type === "decimal") {
                    this.tableData[row][col] = !Number.isNaN(parseFloat(value.trim(), 10)) && isFinite(value) ? parseFloat(value.trim(), 10) : value; // eslint-disable-line
                    this.setRowForSave(this.tableData[row][this.iid]);
                } else if (type === "string") {
                    this.tableData[row][col] = value.trim();
                    this.setRowForSave(this.tableData[row][this.iid]);
                }
                this.cellValueChanged = false;
            }
        },
        getSavePayload() {
            const payload = {
                add: [],
                delete: [],
                edit: [],
                entityCode: this.entity.code
            };
            const rows = Object.entries(this.dataForSaveRequest);
            rows.forEach(([key, value]) => {
                const currentRowData = this.getRowDataById(key);
                const empty = this.rowIsEmpty(currentRowData);
                if (!empty) {
                    payload[value].push(currentRowData);
                } else if (value === "edit") {
                    payload.delete.push(key);
                }
            });
            return payload;
        },
        saveData() {
            this.cellValueChanged = false;
            this.inputValueChanged = false;
            setTimeout(() => {
                const payload = this.getSavePayload();
                this.saveEntityData(payload).then(resp => {
                    if (resp.status === 200) {
                        this.refreshData();
                        this.$root.$emit("savedSuccessfully");
                    }
                });
            }, 100);
        },
        refreshData() {
            this.$emit("refreshData");
        },
        refreshDataTable() {
            if (this.cellValueChanged || this.inputValueChanged) {
                this.showDialogWarning = true;
            } else {
                this.$emit("refreshData");
                this.$emit("refreshEntity", this.entity.code);
            }
        },
        refreshEntity() {
            this.$emit("refreshEntity", this.entity.code);
        },
        addColumn(event) {
            if (this.nothingToSave) {
                this.openColumnModal = true;
                this.addAttInEntity = event;
                this.openAttEdit = false;
                this.attDataToEdit = {
                    code: "",
                    name: ""
                };
            } else {
                this.openWarning = true;
                this.okActionEntity = () => {
                    this.refreshData();
                    this.openColumnModal = true;
                    this.addAttInEntity = event;
                    this.openAttEdit = false;
                    this.attDataToEdit = {
                        code: "",
                        name: ""
                    };
                };
            }
        },
        addNewRow() {
            if (!this.tableData.length && this.columns[0].name !== "deleteColumn") {
                this.columns.unshift({ ...this.deleteColumn });
            }
            const uniqRow = this.columns.reduce((acc, item) => ({ ...acc, [item.name]: "" }), { [this.iid]: uid() });
            this.tableData.unshift(uniqRow);
            this.dataForSaveRequest = { ...this.dataForSaveRequest, [uniqRow[this.iid]]: "add" };
        },
        selectedRowIdsHandler(newVal) {
            if (!this.rowIdsSet) return;
            const newValSet = new Set(newVal);
            const intersection = [...this.rowIdsSet].filter(rId => newValSet.has(rId));
            if (intersection.length === this.rowIdsSet.size) {
                this.selectAllRows = true;
            } else {
                this.selectAllRows = false;
            }
        },
        selectAllChange(val) {
            this.selectAllRows = val;
            if (val) {
                this.selectedRowIds = [...new Set([...this.selectedRowIds, ...this.rowIdsSet])];
            } else {
                this.selectedRowIds = this.selectedRowIds.filter(rowId => !this.rowIdsSet.has(rowId));
            }
        },
        selectedOption(event) {
            const { value } = event[0];
            if (value === "edit") {
                this.getIntegrationList(false);
            } else if (value === "export") {
                this.showExportMenu = true;
            } else if (value === "importData") {
                this.openImportDataEntityModal = true;
            } else if (value === "dataAudit") {
                this.openDataAudit = true;
            } else if (value === "deleteData") {
                this.enterBulkDeleteMode();
            } else if (value === "deleteAllData") {
                this.deleteAllDialog = true;
            } else if (value === "permissions") {
                this.permissionsModal = true;
            } else if (value === "deleteTable") {
                this.deleteTable();
            }
            this.resetSelectedData = true;
        },
        editAtt(att) {
            if (!this.readOnly && !this.isExternal) {
                if (this.nothingToSave) {
                    this.attDataToEdit = { ...att };
                    const codes = {
                        attributeCode: this.attDataToEdit.code,
                        entityCode: this.entity.code
                    };
                    this.checkAttStatus(codes);
                    this.openAttEdit = true;
                    this.openColumnModal = true;
                } else {
                    this.openWarning = true;
                    this.okActionEntity = () => {
                        this.refreshData();
                        this.attDataToEdit = { ...att };
                        const codes = {
                            attributeCode: this.attDataToEdit.code,
                            entityCode: this.entity.code
                        };
                        this.checkAttStatus(codes);
                        this.openAttEdit = true;
                        this.openColumnModal = true;
                    };
                }
            }
        },
        checkAttStatus(/* codes */) {
            this.attIsPublished = true;
        },
        getRowDataById(rid) {
            let rowData = this.tableData.find(row => row[this.iid] === rid);
            if (rowData) {
                rowData = { ...rowData };
                delete rowData.__index;
                delete rowData.deleteColumn;
            }
            return rowData;
        },
        rowIsEmpty(row) {
            const rowData = Object.entries(row);
            return !rowData.find(([, value]) => value !== "" && value !== null);
        },
        removeRow(row) {
            const indexToDelete = row.index;
            const rowT = row;
            delete row.index;
            const isEmpty = this.rowIsEmpty(rowT);
            const notSaved = this.dataForSaveRequest.hasOwnProperty(rowT[this.iid]) && this.dataForSaveRequest[rowT[this.iid]] === "add";
            if (isEmpty || notSaved) {
                this.tableData.splice(indexToDelete, 1);
            } else {
                const payload = {
                    entityCode: this.entity.code,
                    rowId: row.id
                };
                this.deleteRows(payload).then(resp => {
                    if (resp.status === 200) {
                        this.tableData.splice(indexToDelete, 1);
                        if (!this.tableData.length) {
                            if (this.nothingToSave) {
                                this.refreshData();
                            }
                        }
                    }
                });
            }
            delete this.dataForSaveRequest[rowT[this.iid]];
            if (!this.tableData.length) {
                this.columns.splice(0, 1);
            }
            if (!Object.keys(this.dataForSaveRequest).length) {
                this.inputValueChanged = false;
            }
            delete this.invalidCellIds[rowT[this.iid]];
            this.saveDisabled = !!Object.keys(this.invalidCellIds).length;
        },
        deleteSelectedRows() {
            const payload = {
                entityCode: this.entity.code,
                add: [],
                update: [],
                delete: this.selectedRowIds
            };
            this.saveEntityData(payload).then(resp => {
                if (resp.status === 200) {
                    this.$toast.showNotify({
                        message: this.$t("globalDataModel.dataDeleted"),
                        type: "success"
                    });
                    this.refreshData();
                    this.exitBulkDeleteMode();
                }
            });
        },
        deleteAllRows() {
            this.deleteAllData(this.entity.code).then(resp => {
                if (resp.status === 200) {
                    this.$toast.showNotify({
                        message: this.$t("globalDataModel.dataDeleted"),
                        type: "success"
                    });
                    this.refreshData();
                    this.exitBulkDeleteMode();
                }
            });
        },
        deleteTable() {
            const payload = {
                entityCode: this.entity.code,
                entityName: this.entity.name
            };
            this.$emit("deleteEntity", payload);
        },
        addNewAttribute(att) {
            const column = {
                [this.iid]: uid(),
                code: att.code,
                type: att.type,
                name: att.name,
                label: att.name,
                field: att.name,
                isPublished: true,
                align: "left",
                required: true,
                personalInfo: att.personalInfo
            };
            this.columns.push(column);
        },
        onOk() {
            if (typeof this.okActionEntity === "function") {
                this.okActionEntity();
            }
            this.inputValueChanged = false;
            this.cancelActionEntity = null;
            this.okActionEntity = null;
        },
        onCancel() {
            if (typeof this.cancelActionEntity === "function") {
                this.cancelActionEntity();
            }
            this.openWarning = false;
            this.okActionEntity = null;
            this.cancelActionEntity = null;
        },
        refreshList(ok) {
            if (ok) {
                this.$emit("refreshData");
            }
            this.showDialogWarning = false;
        }
    }
};
